// extracted by mini-css-extract-plugin
export var card = "_ok-0";
export var content = "_ok-2";
export var details = "_ok-3";
export var icon = "_ok-1";
export var iconBlue = "_ok-5";
export var iconBrand = "_ok-4";
export var iconGrayBlue = "_ok-6";
export var iconGreen = "_ok-7";
export var iconIndigo = "_ok-8";
export var iconOrange = "_ok-9";
export var iconPurple = "_ok-a";
export var iconRed = "_ok-b";
export var iconWarning = "_ok-c";